var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCirclePentool = function SvgCirclePentool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8a8 8 0 0 0-5.62 13.694l1.671-5.01a.997.997 0 0 1 .054-.131l3-6a1 1 0 0 1 1.79 0l3 6c.02.042.039.086.053.13l1.67 5.012A8 8 0 0 0 12 4Zm0 16a7.964 7.964 0 0 1-3.935-1.033l1.861-5.583.192-.384h3.764l.192.384 1.86 5.583A7.963 7.963 0 0 1 12 20Z",
    fill: "currentColor",
    fillOpacity: 0.64
  })));
};
export default SvgCirclePentool;